// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-58b0e280]:export{primaryColor:#004e87}a[data-v-58b0e280]{margin-right:20px;margin-top:2px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
